const { dataLayerListener } = require('./data-layer.cjs');
const { alfaPartners } = require('./partners.cjs');
const { platformIdReady } = require('./platform-id-ready.cjs');
const { ytm, ytmCookie, ytmNoScript, ytmSendEvent, ytmSendUserParams } = require('./ytm.cjs');

const getCounters = (url, data) => {
    const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
    const {
        collectorData: { host },
        pageContent: { webAnalytics }
    } = data;
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
    const ytmScripts = [
        ytmNoScript,
        ytmCookie,
        dataLayerListener,
        ytmSendUserParams,
        ytmSendEvent(webAnalytics)
    ];
    const headYTM = enableYtm ? ytm(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';

    return {
        headCounters: [platformIdReady, headYTM],
        bodyCounters: [bodyYTM, isCountersEnabled ? alfaPartners(url) : ''],
        endBodyCounters: []
    };
};

module.exports = {
    getCounters
};
